/* Add to Shortlist from collection cards, without leaving the page.

   A facility buyer assembles 20-40 lines. Bouncing them to the cart after every
   single add would make that unbearable, so the add happens in place and the
   header count updates. The form still has a real action and return_to, so with
   JavaScript off it degrades to a normal POST rather than doing nothing. */
(function () {
  'use strict';

  function setCount(n) {
    document.querySelectorAll('[data-sp-quote-count]').forEach(function (el) {
      el.textContent = n;
    });
    // The header CTA only renders its count once the cart is non-empty. If this
    // is the first item, reload so the button switches into its counted state
    // rather than leaving the buyer with no visible confirmation anywhere.
    if (!document.querySelector('[data-sp-quote-count]')) window.location.reload();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form.sp-card-quote');
    if (!form) return;
    event.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    var original = button.textContent.trim();
    button.disabled = true;
    button.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: form.querySelector('[name="id"]').value,
        quantity: 1
      })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        button.classList.add('is-added');
        button.textContent = 'Added to shortlist ✓';
        setTimeout(function () {
          button.disabled = false;
          button.classList.remove('is-added');
          button.textContent = original;
        }, 2200);
      })
      .catch(function () {
        // Fall back to a real form submit rather than losing the click.
        button.textContent = original;
        button.disabled = false;
        form.submit();
      });
  });
})();
